import { useState, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ImageUploader = () => {
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);

  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(Array.from(event.dataTransfer.files));
  };

  const handleFiles = (files) => {
    const validFiles = files.filter((file) =>
      ["image/jpeg", "image/jpg", "image/png"].includes(file.type)
    );

    if (validFiles.length + images.length > 10) {
      toast.error("You can only upload a maximum of 10 images.");
      return;
    }

    const resizedFiles = validFiles.filter((file) => file.size <= 500 * 1024);

    if (resizedFiles.length !== validFiles.length) {
      toast.warning("Some files exceeded the 500KB limit and were not uploaded.");
    }

    const newImageUrls = resizedFiles.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => [...prevImages, ...newImageUrls]);

  };

  const handleFileInput = (event) => {
    handleFiles(Array.from(event.target.files));
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
    toast.info("Image removed!");
  };

  return (
    <div className="upload-container">
      <div
        className="drop-area"
        onClick={() => fileInputRef.current.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <i className="fa fa-cloud-upload-alt upload-icon"></i>
        <p className="drag-text">Drag & Drop or Click to Upload</p>
        <p className="info-text">Only JPG, JPEG, PNG | Max 10 images | 500KB/image</p>

        <input
          type="file"
          ref={fileInputRef}
          accept="image/jpeg, image/jpg, image/png"
          multiple
          onChange={handleFileInput}
          className="file-input"
        />
      </div>

      <div className="preview-container">
        {images.map((img, index) => (
          <div key={index} className="preview-box">
            <img src={img} alt={`preview ${index}`} />
            <button
              className="delete-btn-image"
              onClick={(event) => {
                event.preventDefault();
                removeImage(index);
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUploader;
